export const CAL_EVENT_CONTACT_CONSTRAINTS = {
    name: { maxLength: 200, label: 'Name' },
    phone: { maxLength: 40, label: 'Phone' },
    email: { maxLength: 254, label: 'Email' },
    company: { maxLength: 200, label: 'Company' },
    role: { maxLength: 120, label: 'Role' },
    note: { maxLength: 2000, label: 'Note' },
};
//# sourceMappingURL=constraints.js.map